import { all, takeEvery, put, call } from 'redux-saga/effects'
import { getProvincias, updateProvincia } from 'services/logisticaPedido'
import { actions } from './actions'
import { putMessage, messageType } from '../../utiles/mensaje'

export function* GET_PROVINCIAS() {
  try {
    const provinciasData = yield call(getProvincias)
    if (provinciasData.ok) {
      yield put({
        type: actions.PROVINCIAS_LOAD_SUCCEEDED,
        payload: provinciasData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar provincias')
      put({
        type: actions.PROVINCIAS_LOAD_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.PROVINCIAS_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* UPDATE_PROVINCIA(action) {
  try {
    const provinciaObj = yield call(updateProvincia, action.payload)
    if (provinciaObj.ok) {
      putMessage(messageType.SUCCESS, 'Provincia modificada correctamente')
      yield put({
        type: actions.PROVINCIA_UPDATE_SUCCEEDED,
        payload: provinciaObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al modificar provincia')
      yield put({
        type: actions.PROVINCIA_UPDATE_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al modificar provincia')
    yield all([
      put({
        type: actions.PROVINCIA_UPDATE_FILED,
        error: e.message,
      }),
    ])
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.PROVINCIAS_LOAD_REQUESTED, GET_PROVINCIAS),
    takeEvery(actions.PROVINCIA_UPDATE_REQUESTED, UPDATE_PROVINCIA),
  ])
}
